const state = {
  tags: [],
  tagsByType: {
    contact: [],
    employer: [],
    attendance_group: [],
  },
  attendanceTagsByProtocol: {},
  attendanceTagItemsByProtocol: {},
};

export default state;
